import { PublicPath } from '@/utils/constant';
import img1 from '@/assets/images/stories/1.jpg';
import img2_1 from '@/assets/images/stories/2-1.jpg';
import img2_2 from '@/assets/images/stories/2-2.jpg';
import img3 from '@/assets/images/stories/3.jpg';
import img4_1 from '@/assets/images/stories/4-1.jpg';
import img4_2 from '@/assets/images/stories/4-2.jpg';
import img6 from '@/assets/images/stories/6.jpg';
import img7 from '@/assets/images/stories/7.jpg';
import img8 from '@/assets/images/stories/8.jpg';
import img8_2 from '@/assets/images/stories/8-2.jpg';
import img8_3 from '@/assets/images/stories/8-3.jpg';
import img13 from '@/assets/images/stories/13.jpg';
import img15_2 from '@/assets/images/stories/15-2.jpg';
import img15_3 from '@/assets/images/stories/15-3.jpg';
import img15_4 from '@/assets/images/stories/15-4.jpg';
import img17_1 from '@/assets/images/stories/17-1.jpg';
import img17_2 from '@/assets/images/stories/17-2.jpg';
import img17_3 from '@/assets/images/stories/17-3.jpg';
import img17_4 from '@/assets/images/stories/17-4.jpg';
import img18_1 from '@/assets/images/stories/18-1.jpg';
import img18_2 from '@/assets/images/stories/18-2.jpg';
import img18_3 from '@/assets/images/stories/18-3.jpg';
import img18_4 from '@/assets/images/stories/18-4.jpg';
import video_5 from '@/assets/video/5.mp4';
import video_9 from '@/assets/video/9.mp4';
import video_10 from '@/assets/video/10.mp4';
import video_11 from '@/assets/video/11.mp4';
import video_12 from '@/assets/video/12.mp4';
import video_14 from '@/assets/video/14.mp4';
import video_15 from '@/assets/video/15.mp4';
import video_16 from '@/assets/video/16.mp4';
import video_16_2 from '@/assets/video/16_2.mp4';
import video_18 from '@/assets/video/18.mp4';
import poster_5 from '@/assets/images/video/5.jpg';
import poster_9 from '@/assets/images/video/9.jpg';
import poster_10 from '@/assets/images/video/10.jpg';
import poster_11 from '@/assets/images/video/11.jpg';
import poster_12 from '@/assets/images/video/12.jpg';
import poster_14 from '@/assets/images/video/14.jpg';
import poster_15 from '@/assets/images/video/15.jpg';
import poster_16 from '@/assets/images/video/16.jpg';
import poster_16_2 from '@/assets/images/video/16_2.jpg';
import poster_18 from '@/assets/images/video/18.jpg';

export type StoryType = {
    preview: string;
    images: { src: any; type: string; poster?: any }[];
    id: number;
    text: (JSX.Element | string)[];
    fullText?: JSX.Element;
    tags: string[];
    pixel: string;
};
export const stories: StoryType[] = [
    {
        id: 1,
        preview: 'Привет! Сессия всё, впереди практика ✌️',
        images: [
            {
                type: 'image',
                src: img1,
            },
        ],
        text: [
            <>
                <p>
                    Мы учимся на «Маркшейдерском деле» — это новая специальность, которая появилась
                    в Тюменском индустриальном университете в 2021-м году.
                </p>
                <p>
                    Паша: «Моя мама — фельдшер. Поэтому в старших классах выбирал между двумя
                    направлениями: медицина и архитектура. А в итоге решил стать… маркшейдером){' '}
                </p>
                <p>
                    В этой профессии много всего намешано: инженерное дело, строительство, геодезия,
                    математика, моделирование, геометрия, проектная деятельность и даже философия!
                </p>
            </>,
            <p key={'s1ls'}>
                Попробуй не стать философом, когда работаешь с моделями будущего 😀 Пускай это
                будущее воплощено в объектах, которые появятся в результате твоих расчетов».
            </p>,
        ],
        tags: ['photo', 'markshader', 'private'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqiu&pr=%random%&ptrc=b',
    },
    {
        id: 2,
        preview: '✈️ Тюмень — Новый Уренгой. Дальше вертолетом до Мессояхи',
        images: [
            {
                type: 'image',
                src: img2_1,
            },
            {
                type: 'image',
                src: img2_2,
            },
        ],
        text: [
            <>
                <p>
                    По-другому на Мессояху никак не добраться, по крайней мере летом. На весь путь
                    ушли почти сутки: Ямал встретил нас дождливой и ветреной погодой, вертолет
                    задержали.
                </p>
                <p>
                    Дима: «Мой отец — инженер, я с детства фанател от проектирования. Хотя у меня
                    вообще много увлечений: Формула-1 (команда Red Bull и Макса Ферстаппен — топ),
                    моделирование (в школе за несколько месяцев спроектировал автоматическую
                    трансмиссию) и новые технологии.
                </p>
                Профессия маркшейдера объединила все мои интересы. Ну и хороший заработок
                в&nbsp;перспективе))
            </>,
            <>
                Жду, когда на практике поработаю с дронами, цифровыми КАМАЗами и вездеходами. Не
                гоночные болиды, но тоже круто» 😎
            </>,
        ],
        tags: ['photo', 'markshader', 'private'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqiv&pr=%random%&ptrc=b',
    },
    {
        id: 3,
        preview: '🌏❄️ Попасть в Арктику было нашей мечтой',
        images: [
            {
                type: 'image',
                src: img3,
            },
        ],
        text: [
            <>
                <p>
                    Наш вуз сотрудничает с «Газпром нефтью», эта компания всегда обращает внимание
                    на перспективных студентов, а лучших приглашает на практику и работу!
                </p>
                <p>
                    <b>
                        Как попасть на практику в&nbsp;«Газпром нефть» и&nbsp;стать частью команды:{' '}
                        <a
                            href={
                                'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=quoxv&pr=%random%'
                            }
                            target={'_blank'}
                            rel={'noopener noreferrer'}
                        >
                            читайте&nbsp;тут
                        </a>
                        .
                    </b>
                </p>
                <p>
                    И мы очень старались! Первые 2 года в&nbsp;универе изучали нефтяное дело,
                    геодезию, проектную деятельность. Участвовали и побеждали в профильных конкурсах
                    и кейс-чемпионатах, с утра до ночи (а иногда и по ночам, чего уж там)
                    прокачивали знания, ну и закрепили все зачетками с&nbsp;отличием 🤟
                </p>
            </>,
            <>
                <p>
                    Дима: «Я состою в вузовском Арктическом научном сообществе. Прожужжал друзьям
                    все уши про Север. Считаю, что будущее нефтянки — за Арктикой. Ее нужно изучать,
                    понимать и вкладываться в развитие. Надеюсь когда-нибудь там поработать.
                </p>
                <b>
                    Все о стажировке и&nbsp;практике для молодых специалистов{' '}
                    <a
                        href={
                            'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=quoxx&pr=%random%'
                        }
                        target={'_blank'}
                        rel={'noopener noreferrer'}
                    >
                        в&nbsp;нашем телеграм-канале
                    </a>
                    . Подписывайтесь!
                </b>
            </>,
        ],
        tags: ['photo', 'markshader', 'private'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqiw&pr=%random%&ptrc=b',
    },
    {
        id: 4,
        preview: 'Немного космических видов 💥',
        images: [
            {
                type: 'image',
                src: img4_1,
            },
            {
                type: 'image',
                src: img4_2,
            },
        ],
        text: [
            <>
                <p>
                    Восточно-Мессояхское месторождение находится на Гыданском полуострове. Это Ямал.
                    Край земли.
                </p>
                <p>
                    Здесь как на другой планете 🌏 Все другое: рельеф, растения, небо, воздух,
                    краски — сильно отличается от Тюмени, Крыма (Паша вырос в крымском поселке
                    Кировское) или Кургана (родной город Димы).
                </p>
                <p>
                    Хотя вид Тазовской губы, окаймленной зеленой тундрой, с воздуха можно перепутать
                    с видами какого-нибудь морского курорта. Ну, если забыть, что за бортом около
                    +10°С 😅
                </p>
                Отсюда до Северного полярного круга{' '}
            </>,
            <>
                рукой подать — 250 км. Почти как от Москвы до&nbsp;Ярославля или от&nbsp;Тюмени
                до&nbsp;Екатеринбурга.
            </>,
        ],
        tags: ['photo', 'messoyakha'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqiy&pr=%random%&ptrc=b',
    },
    {
        id: 5,
        preview: 'Маркшейдер — это горный инженер ⚒️',
        images: [
            {
                type: 'video',
                src: video_5,
                poster: poster_5,
            },
        ],
        text: [
            <>
                <p>Гор на Мессояхе нет, сплошь тундра, но инженерной работы полно.</p>
                <p>
                    На нефтепромысле маркшейдер — обязательный участник всех процессов 💯 Он
                    сопровождает весь жизненный цикл месторождения, от проектирования до
                    рекультивации после завершения работ.
                </p>
                Еще на стадии геологоразведки маркшейдеры проводят инженерные и геодезические
                изыскания, составляют карты, переносят с бумаги на «землю» контуры будущих объектов
                (чтобы скважина не попала, например, в речку), создают 3D-модели, контролируют
                эксплуатацию
            </>,
            <>
                {' '}
                объектов.
                <p>
                    А при строительстве дорог определяют оси, по которым будут прокладывать
                    транспортные пути 🚞
                </p>
            </>,
        ],
        tags: ['video', 'markshader', 'watch'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqis&pr=%random%&ptrc=b',
    },
    {
        id: 6,
        preview: 'А кто такой нефтяник тогда 🤔',
        images: [
            {
                type: 'image',
                src: img6,
            },
        ],
        text: [
            <>
                <p>
                    Что первым приходит вам в голову при слове «нефтянка»? Спорим, станок-качалка
                    или геологи — обязательно с бородой и обмазанные нефтью? Развеиваем этот
                    бородатый миф🧔‍♂️
                </p>
                <p>Нефтедобывающая индустрия сегодня — на пике «цифры» и технологий 🚀</p>А
                нефтяниками на Мессояхе называют себя представители почти 200 профессий и
                специальностей. Это люди, которые напрямую занимаются добычей, а еще инженеры,
                проектировщики, трубопроводчики, операторы, технологи, геодезисты. И маркшейдеры))
            </>,
        ],
        tags: ['photo', 'messoyakha', 'markshader'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqim&pr=%random%&ptrc=b',
    },
    {
        id: 7,
        preview: 'Главный друг маркшейдера — цифра 🐝 ',
        images: [
            {
                type: 'image',
                src: img7,
            },
        ],
        text: [
            <>
                <p>
                    Нам поставили задачу сделать точную модель Центрального пункта сбора нефти
                    (ЦПС), чтобы проверить, не произошло ли деформации грунта за шесть лет работы.
                    Для Мессояхи это вопрос принципиальный: месторождение стоит на вечной мерзлоте и
                    берегут ее как зеницу ока&nbsp;👁️
                </p>
                <p>
                    Отснять нужно 70 га. Делать это «ногами» — уйдет месяц. Спутниковая навигация не
                    возьмет — высокая металлоемкость, плотная застройка. А&nbsp;этой «пчелкой» мы
                    управимся за&nbsp;день ✌️
                </p>
                По полученным материалам маркшейдеры создадут облако точек,
            </>,
            <>
                потом прогонят его через специальные программы, построят 3D-модель, сравнят ее с
                проектными данными и сделают выводы о состоянии грунта. Круто же?)
            </>,
        ],
        tags: ['photo', 'markshader'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqjb&pr=%random%&ptrc=b',
    },
    {
        id: 8,
        preview: 'Еще один рабочий гаджет — тахеометр 📸',
        images: [
            {
                type: 'image',
                src: img8,
            },
            {
                type: 'image',
                src: img8_2,
            },
            {
                type: 'image',
                src: img8_3,
            },
        ],
        text: [
            <>
                <p>
                    Очередная задачка маркшейдера: проверить целостность
                    резервуаров-десятитысячников, в которых хранится нефть перед отправкой.
                </p>
                <p>
                    Здесь дроны не помогут, нужен тахеометр — не обычный, а сканирующий. На Мессояхе
                    есть и такое! С помощью этого скана мы проверим швы резервуара, создадим
                    3D-модель и убедимся в целостности и надежности РВС.
                </p>
            </>,
        ],
        tags: ['photo', 'markshader', 'messoyakha'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqja&pr=%random%&ptrc=b',
    },
    {
        id: 9,
        preview: 'Чем себя развлечь на краю земли 🎮🏋🏓',
        images: [
            {
                type: 'video',
                src: video_9,
                poster: poster_9,
            },
        ],
        text: [
            <>
                <p>
                    Как в Арктике работают — более или менее понятно. А вот как в Арктике отдыхают?
                </p>
                <p>
                    С этим на Мессояхе тоже все отлично, чего тут только нет: тренажеры, волейбол,
                    футбол, баскетбол, настольный теннис, зона отдыха с книгами, настолками,
                    кофемашиной и массажными креслами. Наша любовь — игровая консоль 😁 Но спортом
                    мы тоже занимаемся.
                </p>
            </>,
        ],
        tags: ['video', 'messoyakha', 'watch'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqiz&pr=%random%&ptrc=b',
    },
    {
        id: 10,
        preview: 'Мама, у меня все хорошо 🤗',
        images: [
            {
                type: 'video',
                src: video_10,
                poster: poster_10,
            },
        ],
        text: [
            <>
                <p>Обзор условий жизни на Большой земле специально для мамы)</p>
                <p>
                    Мессояха — второй дом для 600 вахтовиков, на минуточку. Нефтяники проводят здесь
                    половину года: режим вахт месяц через месяц. И условия здесь близкие к домашним.
                    Очень уютно. Живут в общежитиях — по два человека в комнате.
                </p>
                <p>
                    На видео наша с Пашей комната в одном из пяти общежитий. Отмечу блэкаут-шторы:
                    ночи здесь белые, полярные, и единственная возможность выспаться — установить с
                    вечера затемнение.
                </p>
            </>,
        ],
        tags: ['video', 'messoyakha'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqix&pr=%random%&ptrc=b',
    },
    {
        id: 11,
        preview: 'Встречайте ТРЭКОЛ 😎🤟',
        images: [
            {
                type: 'video',
                src: video_11,
                poster: poster_11,
            },
        ],
        text: [
            <>
                <p>
                    Чем хороша практика на Мессояхе — здесь можно увидеть то, чего в больших городах
                    не встретишь. Например, ТРЭКОЛ. Расшифровывается как Транспорт Экологический.
                </p>
                <p>
                    Эта двухтонная шестиколесная машинка при движении не нарушает тундровый покров,
                    потому что давление в шинах щадящее — всего 0,1 кПа. Может добраться в самую
                    непроходимую точку тундры, если надо. А маркшейдерам надо!
                </p>
            </>,
        ],
        tags: ['video', 'markshader', 'messoyakha'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqio&pr=%random%&ptrc=b',
    },
    {
        id: 12,
        preview: 'Едем на умное месторождение',
        images: [
            {
                type: 'video',
                src: video_12,
                poster: poster_12,
            },
        ],
        text: [
            <>
                <p>
                    На видео цифровая буровая. У этой махины высотой 70 метров и весом под сотню
                    тонн реально есть мозг 🧠
                </p>
                <p>
                    Искусственный интеллект в режиме автопилота контролирует безопасность и точность
                    бурения с учетом геологических особенностей пласта и заданных параметров. Данные
                    из недр сразу передаются в Тюмень, в Центр строительства скважин.
                </p>
                <p>
                    Недавно пробурили очередную скважину на ачимовке — это такие сложные пласты с
                    высоким давлением на глубине ниже 3 км.
                </p>
            </>,
        ],
        tags: ['video', 'watch'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqit&pr=%random%&ptrc=b',
    },
    {
        id: 13,
        preview: 'А это цифровой куст добычи 🪴',
        images: [
            {
                type: 'image',
                src: img13,
            },
        ],
        text: [
            <>
                <p>
                    Выглядит как обычная кустовая площадка, да? На самом деле она вся нашпигована
                    цифровыми штуками: регулирующими клапанами, датчиками, тепловизорами,
                    видеокамерами с FullHD.
                </p>
                <p>
                    Искусственный интеллект, который все это регулирует, снимает нагрузку с людей.
                    Зимой очень актуально: до минимума сокращает частоту ручных операций и ремонтов,
                    а если что пойдет не так, система в ту же секунду передаст сообщение на пульт
                    диспетчера ⚡
                </p>
            </>,
        ],
        tags: ['photo', 'messoyakha', 'markshader'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqin&pr=%random%&ptrc=b',
    },
    {
        id: 14,
        preview: 'Им сверху видно все, так и знайте! 👀',
        images: [
            {
                type: 'video',
                src: video_14,
                poster: poster_14,
            },
        ],
        text: [
            <>
                <p>
                    Вот это крыло, похожее на воздушного змея, проверяет с воздуха целостность
                    трубопроводов. За один рейс он может промониторить трубу протяженностью до 240
                    км. Представляете, сколько дней нужно человеку, чтобы такое расстояние пройти
                    ногами? А тут поднял в воздух эту штуку, она 4 часа полетала безостановочно, и
                    полная картина у тебя в мониторе или на планшете 🦾
                </p>
                <p>
                    А еще с помощью крыла можно вести дополнительный контроль за состоянием всех
                    объектов и тундры в пожароопасный период!
                </p>
            </>,
        ],
        tags: ['video', 'messoyakha'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqip&pr=%random%&ptrc=b',
    },
    {
        id: 15,
        preview: 'Обед в столовке за 190 рублей 🍽️ ',
        images: [
            {
                type: 'video',
                src: video_15,
                poster: poster_15,
            },
            {
                type: 'image',
                src: img15_2,
            },
            {
                type: 'image',
                src: img15_3,
            },
            {
                type: 'image',
                src: img15_4,
            },
        ],
        text: [
            <>
                <p>
                    Каждый день здесь завтракают, обедают и ужинают 600 человек. В ежедневное
                    обеденное меню столовой «Мессояхи» входит: 5 салатов, 4 супа, 7 горячих, 5
                    гарниров, соусы, десерты, чай, кофе, компоты и морсы, кисломолочная продукция и
                    8 видов выпечки!!
                </p>
                <p>
                    Например, полноценный обед — первое, второе, салат, десерт, напиток — обошелся в
                    190 рублей 🤩 Кстати, Паше на день рождения местные повара приготовили
                    вкуснейший торт. Со свечками! 😀
                </p>
            </>,
        ],
        tags: ['video', 'messoyakha', 'private'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqiq&pr=%random%&ptrc=b',
    },
    {
        id: 16,
        preview: '🔊 ASMR пушица на ветру ',
        images: [
            {
                type: 'video',
                src: video_16,
                poster: poster_16,
            },
            {
                type: 'video',
                src: video_16_2,
                poster: poster_16_2,
            },
        ],
        text: [
            <>
                <p>
                    Еще одна причина популярности Мессояхских месторождений у гыданских оленеводов:
                    здесь много ягеля. Для оленя этот лишайник — первое, второе и компот в одном
                    блюде. Экология на Мессояхе хорошая, и ягеля — целые поляны.
                </p>
                <p>
                    Летом оленеводов мало: большинство уходит со стадами севернее, к Карскому морю.
                    Это называется каслание. К зиме вернутся и поставят здесь свои чумы с видом на
                    нефтепромысел.
                </p>
            </>,
        ],
        tags: ['video', 'messoyakha'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqir&pr=%random%&ptrc=b',
    },
    {
        id: 17,
        preview: 'Напоследок показываем красивое  🌼',
        images: [
            {
                type: 'image',
                src: img17_1,
            },
            {
                type: 'image',
                src: img17_2,
            },
            {
                type: 'image',
                src: img17_3,
            },
            {
                type: 'image',
                src: img17_4,
            },
        ],
        text: [
            <>
                <p>
                    Погода в этих местах суровая. Круглый год на Мессояхе не прекращаются сильные
                    ветра. Летом они несут спасение от «стад» мошек и комаров, а зимой делают
                    здешние морозы под -50° С испытанием даже для экстремалов! Бррр
                </p>
                <p>
                    Поводов влюбиться в эту землю — столько же, сколько звезд над Гыданской тундрой
                    долгой полярной ночью. Работать в Арктике и не стать романтиком не получится.
                </p>
                <p>А это просто галерея фотографий, которыми хочется поделиться)</p>
            </>,
        ],
        tags: ['photo', 'messoyakha'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqil&pr=%random%&ptrc=b',
    },
    {
        id: 18,
        preview: 'А давайте с нами? 👋',
        images: [
            {
                type: 'image',
                src: img18_1,
            },
            {
                type: 'image',
                src: img18_2,
            },
            {
                type: 'video',
                src: video_18,
                poster: poster_18,
            },
            {
                type: 'image',
                src: img18_3,
            },
        ],
        text: [
            <>
                <p>
                    Наша 30-дневная вахта всё 🥺 С Мессояхой не прощаемся: мы обязательно сюда
                    вернемся!
                </p>
                <p>
                    А давайте на будущий год с нами? В смысле на практику мечты – не обязательно
                    даже на Мессояху и не обязательно в нашей компании)
                </p>
                <ul>
                    <li>
                        <a
                            href={
                                'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=quoxy&pr=%random%'
                            }
                            target={'_blank'}
                            rel={'noopener noreferrer'}
                        >
                            Смотрите список вузов
                        </a>
                        , с которыми сотрудничает «Газпром нефть». Ищите там свой или поступайте в
                        один из универов в Казани, Москве, Санкт-Петербурге, Тюмени или Уфе.
                    </li>
                    <li>
                        <a
                            href={
                                'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=quoxw&pr=%random%'
                            }
                            target={'_blank'}
                            rel={'noopener noreferrer'}
                        >
                            Подписывайтесь на телеграм-канал «В команде»
                        </a>{' '}
                        — здесь все о вакансиях для молодых специалистов, конференциях,{' '}
                    </li>
                </ul>
            </>,
            <>
                <p>стажировке и практике в «Газпром нефти».</p>
                <p>В общем, не прощаемся! Всем успешной учебы 😎💪</p>
            </>,
        ],
        fullText: (
            <>
                <p>
                    Наша 30-дневная вахта всё 🥺 С Мессояхой не прощаемся: мы обязательно сюда
                    вернемся!
                </p>
                <p>
                    А давайте на будущий год с нами? В смысле на практику мечты – не обязательно
                    даже на Мессояху и не обязательно в нашей компании)
                </p>
                <ul>
                    <li>
                        <a
                            href={
                                'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=quoxy&pr=%random%'
                            }
                            target={'_blank'}
                            rel={'noopener noreferrer'}
                        >
                            Смотрите список вузов
                        </a>
                        , с которыми сотрудничает «Газпром нефть». Ищите там свой или поступайте в
                        один из универов в Казани, Москве, Санкт-Петербурге, Тюмени или Уфе.
                    </li>
                    <li>
                        <a
                            href={
                                'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=quoxw&pr=%random%'
                            }
                            target={'_blank'}
                            rel={'noopener noreferrer'}
                        >
                            Подписывайтесь на телеграм-канал «В команде»
                        </a>{' '}
                        — здесь все о вакансиях для молодых специалистов, конференциях, стажировке и
                        практике в «Газпром нефти».
                    </li>
                </ul>
                <p>В общем, не прощаемся! Всем успешной учебы 😎💪</p>
            </>
        ),
        tags: ['video', 'messoyakha', 'photo'],
        pixel: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=fpsiu&pfb=qkqkg&pr=%random%&ptrc=b',
    },
];
